/* MT — comportamiento propio de la tienda (Secador 5 en 1) */

(function () {
  'use strict';

  if (window.__mtScriptsInit) return;
  window.__mtScriptsInit = true;

  function initReveal() {
    var elementos = document.querySelectorAll('.mt-reveal');
    if (!elementos.length) return;

    var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducir) {
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            entrada.target.classList.add('mt-visible');
            observador.unobserve(entrada.target);
          }
        });
      },
      { threshold: 0.01, rootMargin: '0px 0px 80px 0px' }
    );

    elementos.forEach(function (el) { observador.observe(el); });
  }

  function initGaleriaProducto() {
    var galeria = document.querySelector('[data-mt-galeria]');
    if (!galeria) return;

    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (miniatura) {
      miniatura.addEventListener('click', function () {
        var src = miniatura.getAttribute('data-full');
        var alt = miniatura.getAttribute('data-alt') || '';
        if (!src) return;
        principal.src = src;
        principal.alt = alt;
        miniaturas.forEach(function (m) { m.classList.remove('mt-activa'); });
        miniatura.classList.add('mt-activa');
      });
    });
  }

  function initSelectorVariantes() {
    var forms = document.querySelectorAll('[data-mt-producto-form]');
    forms.forEach(function (form) {
      var datosEl = form.querySelector('[data-mt-variantes-json]');
      if (!datosEl) return;

      var variantes;
      try {
        variantes = JSON.parse(datosEl.textContent);
      } catch (e) {
        return;
      }

      var inputId = form.querySelector('input[name="id"]');
      var precioEl = form.querySelector('[data-mt-precio]');
      var precioAntesEl = form.querySelector('[data-mt-precio-antes]');
      var botonComprar = form.querySelector('[data-mt-boton-comprar]');
      var disponibilidadEl = form.querySelector('[data-mt-disponibilidad]');
      var pills = form.querySelectorAll('[data-mt-pill]');

      function moneda(centavos) {
        return (centavos / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
        });
      }

      function opcionesSeleccionadas() {
        var seleccion = [];
        var grupos = {};
        pills.forEach(function (pill) {
          if (pill.classList.contains('mt-activa')) {
            grupos[pill.getAttribute('data-mt-opcion-index')] = pill.getAttribute('data-mt-valor');
          }
        });
        var indices = Object.keys(grupos).sort();
        indices.forEach(function (i) { seleccion.push(grupos[i]); });
        return seleccion;
      }

      function encontrarVariante() {
        var seleccion = opcionesSeleccionadas();
        if (!seleccion.length) return variantes[0];
        return variantes.find(function (v) {
          return v.options.every(function (opt, idx) { return opt === seleccion[idx]; });
        });
      }

      function actualizar() {
        var variante = encontrarVariante();
        if (!variante) return;

        if (inputId) inputId.value = variante.id;
        if (precioEl) precioEl.textContent = moneda(variante.price);

        if (precioAntesEl) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioAntesEl.textContent = moneda(variante.compare_at_price);
            precioAntesEl.hidden = false;
          } else {
            precioAntesEl.hidden = true;
          }
        }

        if (botonComprar) {
          botonComprar.disabled = !variante.available;
          botonComprar.textContent = variante.available
            ? botonComprar.getAttribute('data-texto-disponible')
            : botonComprar.getAttribute('data-texto-agotado');
        }

        if (disponibilidadEl) {
          if (variante.available) {
            disponibilidadEl.textContent = disponibilidadEl.getAttribute('data-texto-disponible');
            disponibilidadEl.classList.add('mt-ok');
            disponibilidadEl.classList.remove('mt-agotado');
          } else {
            disponibilidadEl.textContent = disponibilidadEl.getAttribute('data-texto-agotado');
            disponibilidadEl.classList.add('mt-agotado');
            disponibilidadEl.classList.remove('mt-ok');
          }
        }
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var grupo = pill.getAttribute('data-mt-opcion-index');
          form.querySelectorAll('[data-mt-opcion-index="' + grupo + '"]').forEach(function (p) {
            p.classList.remove('mt-activa');
          });
          pill.classList.add('mt-activa');
          actualizar();
        });
      });

      actualizar();
    });
  }

  function initCantidad() {
    var wraps = document.querySelectorAll('[data-mt-cantidad]');
    wraps.forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var menos = wrap.querySelector('[data-mt-menos]');
      var mas = wrap.querySelector('[data-mt-mas]');
      if (!input) return;

      if (menos) {
        menos.addEventListener('click', function () {
          var valor = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
          input.value = valor;
        });
      }
      if (mas) {
        mas.addEventListener('click', function () {
          var valor = (parseInt(input.value, 10) || 1) + 1;
          input.value = valor;
        });
      }
    });
  }

  function initCopiarEmail() {
    var botones = document.querySelectorAll('[data-mt-copiar-email]');
    botones.forEach(function (boton) {
      var email = boton.getAttribute('data-email');
      var textoCopiar = boton.getAttribute('data-texto-copiar') || 'Copiar';
      var textoCopiado = boton.getAttribute('data-texto-copiado') || '¡Copiado!';

      boton.addEventListener('click', function () {
        function marcarCopiado() {
          boton.textContent = textoCopiado;
          setTimeout(function () {
            boton.textContent = textoCopiar;
          }, 2000);
        }

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(email).then(marcarCopiado).catch(function () {
            marcarCopiado();
          });
        } else {
          var campo = document.createElement('textarea');
          campo.value = email;
          campo.style.position = 'fixed';
          campo.style.opacity = '0';
          document.body.appendChild(campo);
          campo.select();
          try {
            document.execCommand('copy');
          } catch (e) {
            /* silencioso: el email sigue visible como texto para copiarlo a mano */
          }
          document.body.removeChild(campo);
          marcarCopiado();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCopiarEmail();
    initGaleriaProducto();
    initSelectorVariantes();
    initCantidad();
  });
})();
